import React from "react";
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid2';
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { state, temp, ui, } from "../../../../../../../../../interfaces/interfaces";
import { useBlacklist, useCaravanSiteBlacklist, useLastJob } from "./hooks";
import LastJobModal from "../LastJobModal";
import { useAppSelector } from "@store/hooks";
import Box from "@mui/material/Box";

const name = "AreaCoverage";

type Props = {
    parent: string
}
const AreaCoverage: React.FC<Props> = ({ parent }) => {
    // const problemComboTrade = useAppSelector(({ ui }) => ui.ProblemComboTrade)
    const blacklist = useBlacklist()
    const blacklistCaravan = useCaravanSiteBlacklist()
    const lastJob = useLastJob()
    const goBackState = useAppSelector(({ state }) => state.IsAGoBack)
    const quoteState = useAppSelector(({ state }) => state.IsAQuote)
    const problemCoverage = useAppSelector(({ temp }) => temp.ProblemAddressCoverage)
    const possibleCaravanSite = useAppSelector(({ state }) => state.PossibleCaravanSite)

    // useEffect to check last job
    React.useEffect(() => {
        if (lastJob.length > 0) {
            ui.ProblemMsg = `Possible duplicate of job ${lastJob[0].jobId} booked on ${new Date(lastJob[0].dateTimeReceived || 0).toLocaleDateString("en-GB")}`
            ui.ProblemMsgVariant = "warning"
            ui.ProblemShowMsg = true
            state.JobDuplicateJobId = lastJob[0].jobId || 0
            !goBackState?.state && !quoteState && (state.NotesPrevious = `This customer's last job ref is ${lastJob[0].jobId}, it may be a go back so please check the postcode against historic jobs.`)
        }
        else {
            state.JobDuplicateJobId = 0
            !goBackState?.state && !quoteState && (state.NotesPrevious = "")
        }
    }, [goBackState?.state, lastJob, quoteState])

    React.useEffect(() => {
        if (blacklist && problemCoverage) {
            temp.ProblemAddressCoverage = false
        }
    }, [blacklist, problemCoverage])

    React.useEffect(() => {
        if (blacklistCaravan && !possibleCaravanSite) {
            state.PossibleCaravanSite = true
        }
    }, [blacklistCaravan, possibleCaravanSite])

    const debugName = `${parent}▷[${name}]`

    useDebugInformation(debugName, { problemCoverage, blacklist, lastJob })
    return (
        (<Grid
            size={{
                xs: 12,
                sm: 12
            }}>
            <Box sx={(theme) => ({
                width: '100%',
                userSelect: "none",
                '& > * + *': {
                    marginTop: theme.spacing(2),
                },
                '& .MuiAlert-root': { justifyContent: "center" },
            })}>
                {ui.ProblemComboTrade && !blacklist && lastJob.length === 0 &&
                    <Alert variant="outlined"
                        severity={problemCoverage ? "success" : "error"}>
                        {problemCoverage ? `${ui.ProblemComboTrade.tradeDescription} - ${ui.JobCoverage?.msg ? ui.JobCoverage.msg : "We have coverage in the area"}` : `${ui.ProblemComboTrade.tradeDescription} - ${ui.JobCoverage?.msg ? ui.JobCoverage.msg : "No coverage in the area!!"}`}
                    </Alert>}
                {!blacklist && lastJob.length > 0 && !problemCoverage &&
                    <Alert variant="outlined"
                        severity="error">{`${ui.ProblemComboTrade?.tradeDescription} - ${ui.JobCoverage?.msg ? ui.JobCoverage.msg : "No coverage in the area"} We have done work in the past for this customer, please check the postcode against historic jobs.`}
                    </Alert>}
                {blacklist &&
                    <Alert variant="outlined"
                        severity="error">THIS PROPERTY IS BLACKLISTED
                    </Alert>}
                {!blacklist && lastJob.length > 0 && problemCoverage &&
                    <Alert variant="outlined"
                        onClick={() => ui.LastJobModal = true}
                        severity="warning">{`The last ${ui.ProblemComboTrade?.tradeDescription} job booked at this address was on `}<b>{`${new Date(lastJob[0].dateTimeReceived || 0).toLocaleDateString("en-GB")}`}</b>{`, reference `}<b>{`${lastJob[0].jobId}`}</b>{`.\nPlease check that this job is not a duplicate before continuing.`}
                    </Alert>}
                {!blacklist && lastJob.length > 0 &&
                    <LastJobModal parent={debugName} />}
                {blacklistCaravan &&
                    <Alert variant="outlined"
                        severity="warning">This is a possible unathorised caravan site, verify the address before booking.
                    </Alert>
                }
            </Box>
        </Grid>)
    );
}

AreaCoverage.displayName = name;


export default React.memo(AreaCoverage)